module.exports = __webpack_public_path__ + "img/youpaq-logo-footer.55ee20e3.png";